import { DECK_THEME as T, fmt$ } from "../../lib/deckModel";

const TAGS = {
  verified: ["Verified", T.accent, "#fff"], preliminary: ["Preliminary", "#E9EEF2", T.navy], target: ["Target", T.accentSoft, T.accent],
  "to be verified": ["To Be Verified", "#FBF1E6", "#8A5A1F"], market: ["Market Data", T.accent, "#fff"], regional: ["Regional", T.accentSoft, T.accent],
  local: ["Local Submarket", T.accentSoft, T.accent], underwriting: ["ARQITEK Underwriting", T.navy, "#fff"], illustrative: ["Illustrative", "#F1F4F6", T.muted],
};
export const Tag = ({ t, label }) => {
  const [l, bg, fg] = TAGS[String(t || "").toLowerCase()] || [t || "—", "#F1F4F6", T.muted];
  return <span className="inline-block rounded-full px-2.5 py-1 text-[10px] uppercase tracking-[0.14em] whitespace-nowrap" style={{ background: bg, color: fg, fontFamily: T.mono, border: `1px solid ${bg === "#fff" ? T.line : bg}` }}>{label || l}</span>;
};
export const Card = ({ children, className = "", accent, testid }) => (
  <div className={`rounded-2xl border bg-white p-5 sm:p-6 ${className}`} style={{ borderColor: accent ? T.accent : T.line }} data-testid={testid}>{children}</div>
);
export const CardTitle = ({ children }) => <div className="text-[11px] uppercase tracking-[0.2em] mb-4" style={{ color: T.muted, fontFamily: T.mono }}>{children}</div>;
export const SourceLine = ({ r }) => (r?.source || r?.date || r?.geo) ? (
  <div className="mt-3 text-[11px] leading-relaxed" style={{ color: T.muted }}><span style={{ fontFamily: T.mono }} className="uppercase tracking-wider mr-1">Source</span>{[r.source, r.date, r.geo].filter(Boolean).join(" · ")}</div>
) : null;

export const Metric = ({ label, value, sub, tag, src, accent, testid }) => (
  <Card accent={accent} testid={testid}>
    {tag && <div className="mb-3"><Tag t={tag} /></div>}
    <div className="text-sm" style={{ color: T.muted }}>{label}</div>
    <div className="mt-2 text-3xl sm:text-4xl tracking-tight tabular-nums" style={{ color: accent ? T.accent : T.navy, fontFamily: T.serif }}>{value}</div>
    {sub && <div className="mt-1 text-sm" style={{ color: T.charcoal }}>{sub}</div>}
    <SourceLine r={src} />
  </Card>
);

export const Bars = ({ items, max, fmt = fmt$, testid }) => (
  <div className="space-y-4" data-testid={testid}>
    {items.filter((r) => r.value > 0).map((r) => (
      <div key={r.label}>
        <div className="flex justify-between text-sm mb-1.5" style={{ color: r.hl ? T.accent : T.charcoal }}><span className={r.hl ? "font-semibold" : ""}>{r.label}</span><span className="tabular-nums">{fmt(r.value)}</span></div>
        <div className="h-2.5 rounded-full" style={{ background: T.neutral }}>
          <div className="h-2.5 rounded-full transition-[width] duration-700" style={{ width: `${Math.max(2, (r.value / (max || 1)) * 100)}%`, background: r.hl ? T.accent : r.dark ? T.navy : "#9FB3C2" }} />
        </div>
      </div>
    ))}
  </div>
);


export const imgSrc = (u) => (u && u.startsWith("/api") ? `${process.env.REACT_APP_BACKEND_URL}${u}` : u);
